/* eslint-disable camelcase */
import ar_AE from './ar_AE.json';
import ar_SA from './ar_SA.json';
import cs_CZ from './cs_CZ.json';
import da_DK from './da_DK.json';
import de_DE from './de_DE.json';
import el_GR from './el_GR.json';
import en_US from './en_US.json';
import es_ES from './es_ES.json';
import es_MX from './es_MX.json';
import es_PR from './es_PR.json';
import et_EE from './et_EE.json';
import fi_FI from './fi_FI.json';
import fr_CA from './fr_CA.json';
import fr_FR from './fr_FR.json';
import he_IL from './he_IL.json';
import hr_HR from './hr_HR.json';
import hu_HU from './hu_HU.json';
import is_IS from './is_IS.json';
import it_IT from './it_IT.json';
import ja_JP from './ja_JP.json';
import ko_KR from './ko_KR.json';
import lt_LT from './lt_LT.json';
import lv_LV from './lv_LV.json';
import nl_NL from './nl_NL.json';
import no_NO from './no_NO.json';
import pl_PL from './pl_PL.json';
import pt_PT from './pt_PT.json';
import ro_RO from './ro_RO.json';
import sk_SK from './sk_SK.json';
import sl_SI from './sl_SI.json';
import sv_SE from './sv_SE.json';
import th_TH from './th_TH.json';
import tr_TR from './tr_TR.json';
import zh_CN from './zh_CN.json';
import zh_HK from './zh_HK.json';
import zh_TW from './zh_TW.json';

/**
 * Gets the translation for a model for a locale
 * @param {string} locale - en_US, fr_CA
 * @return {object} localized translation object
 */
const translationMappings = (locale) => {
  const translations = {
    ar_AE,
    ar_SA,
    cs_CZ,
    da_DK,
    de_DE,
    el_GR,
    en_US,
    es_ES,
    es_MX,
    es_PR,
    et_EE,
    fi_FI,
    fr_CA,
    fr_FR,
    he_IL,
    hr_HR,
    hu_HU,
    is_IS,
    it_IT,
    ja_JP,
    ko_KR,
    lt_LT,
    lv_LV,
    nl_NL,
    no_NO,
    pl_PL,
    pt_PT,
    ro_RO,
    sk_SK,
    sl_SI,
    sv_SE,
    th_TH,
    tr_TR,
    zh_CN,
    zh_HK,
    zh_TW,
    // Add secondary languages that use translations from other locales
    /* EMEA */
    ar_QA: ar_AE,
    de_AT: de_DE,
    de_CH: de_DE,
    de_LU: de_DE,
    fr_BE: fr_FR,
    fr_CH: fr_FR,
    fr_LU: fr_FR,
    it_CH: it_IT,
    nl_BE: nl_NL,
    /* ASIA/PACIFIC */
    zh_MO: zh_HK,
    /* SOUTH AMERICA */
    es_CL: es_MX,
    es_CO: es_MX,
    es_UY: es_MX,
    /* NORTH AFRICA */
    ar_MA: ar_AE,
    fr_MA: fr_FR,
  };

  if (translations[locale]) {
    return translations[locale];
  }
  return en_US;
};

export default translationMappings;
